import { FC } from 'react';

import { AccountSettings } from '@shared/components/AccountSettings';

export const GiftBrandSettingsPage: FC = function GiftBrandSettingsPage() {
  return <AccountSettings heading="계정정보" />;
};
